import useApi from "./useApiRequest";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";

export const ReportarMovimiento = () => {
  const api = useApi();
  const { givenName } = useSelector((state) => state.auth.user);
  const mutate = async (params) => {
    params.usuario = givenName;
    const data = await api.post(`/administracion-inventario/movimientos/data/reportar/validacion/no-continuo/validacion`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    reportarMovimientoMutation: mutation.mutate,
  };
}

export const RevertirReporte = () => {
  const api = useApi();
  const mutate = async (params) => {
    const data = await api.post(`/movimientos-inventario/reporte/movimientos/panel/reversion/no-continuo`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    revertirReporteoMutation: mutation.mutate,
  };
}

export const RevertirReporteContinuo = () => {
  const api = useApi();
  const mutate = async (params) => {
    const data = await api.post(`/movimientos-inventario/reporte/movimientos/panel/reversion/continuo`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    revertirReporteoMutation: mutation.mutate,
  };
}